// Example customized version
import { CircularProgress, Box } from '@mui/material';

const LoadingSpinner = ({ size = 40 }) => {
  return (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      minHeight="200px"
      sx={{
        '& .MuiCircularProgress-root': {
          color: '#2e7d32' // Custom color matching your theme
        }
      }}
    >
      <CircularProgress size={size} thickness={4} />
    </Box>
  );
};

export default LoadingSpinner;